let _ = require('../_.js');
let $ = jQuery;


// // Helper functions that dont execute on init, but are used globally in the app.
